import { pickGroupListType } from "../controller/StoreController";

/**
 * 주문대기
 */
export const ORDER_WAIT_STATUS = 0;

/**
 * 주문접수
 */
export const ORDER_READY_STATUS = 1;

/**
 * 조리완료
 */
export const ORDER_COM_COOK_STATUS = 2;

/**
 * 배달시작
 */
export const ORDER_START_DEL_STATUS = 6;

/**
 * 배달완료
 */
export const ORDER_COM_DEL_STATUS = 7;

/**
 * 서빙완료
 */
export const ORDER_COM_SERVING_STATUS = 3;

/**
 * 주문완료
 */
export const ORDER_COM_STATUS = 5;

/**
 * 주문취소
 */
export const ORDER_CANCLE_STATUS = 4;

export const PAY_REQUEST_MESSAGE_TYPE = "pay";
export const CANCEL_PAY_REQUEST_MESSAGE_TYPE = "cancel_pay";
export const ACTION_MESSAGE_TYPE = "action";
export const RESTART_PAY_REQUEST_MESSAGE_TYPE = "restart_pay";
export const ORDER_COMPLETE_MESSAGE_TYPE = "order_complete";
export const ECHO_MESSAGE_TYPE = "echo";
export const TOAST_MESSAGE_TYPE = "toast";

export const PRODUCT_TYPE_DELIVERY = 0;
export const PRODUCT_TYPE_EXTENSION = 2;
export const PRODUCT_TYPE_RENTAL_DIRECT = 3;
export const PRODUCT_TYPE_RENTAL_SMS = 4;

export type postMessageType =
  | postMessageToastType
  | postMessageOrderCompleteType
  | postMessageCancelPayType
  | postMessageEchoType
  | postMessageRestartPayType
  | postMessageActionType
  | postMessagePayType
  | postMessagePayType;

export type postMessageOrderCompleteType = {
  type: "order_complete";
  data: {};
};

export type postMessageToastType = {
  type: "toast";
  data: {
    msg: string;
    ms: number;
  };
};

export type postMessagePayType = {
  type: "pay";
  data: {
    amount: number;
    requested_at: Date;
    store_id: number;
  };
};

export type postMessageActionType = {
  type: "action";
  data: { action: "restart" };
};

export type postMessageRestartPayType = {
  type: "restart_pay";
  data: {};
};

export type postMessageEchoType = {
  type: "echo";
  data: any;
};

export type postMessageCancelPayType = {
  type: "cancel_pay";
  data: paymentRealmType;
};

export type categoryNameLangType = {
  category_name_en: string;
  category_name_ch: string;
  category_name_ja: string;
  category_name_th: string;
  category_name_es: string;
  category_name_fr: string;
  category_name_ru: string;
  category_name_de: string;
};

export type prdDescriptionLangType = {
  prd_description_en: string;
  prd_description_ch: string;
  prd_description_ja: string;
  prd_description_th: string;
  prd_description_es: string;
  prd_description_fr: string;
  prd_description_ru: string;
  prd_description_de: string;
};

export type prdNameLangType = {
  prd_name_en: string;
  prd_name_ch: string;
  prd_name_ja: string;
  prd_name_th: string;
  prd_name_es: string;
  prd_name_fr: string;
  prd_name_ru: string;
  prd_name_de: string;
};

export type productNameLangType = {
  product_name_en: string;
  product_name_ch: string;
  product_name_ja: string;
  product_name_th: string;
  product_name_es: string;
  product_name_fr: string;
  product_name_ru: string;
  product_name_de: string;
};

export type optionNameLangType = {
  option_name_en: string;
  option_name_ch: string;
  option_name_ja: string;
  option_name_th: string;
  option_name_es: string;
  option_name_fr: string;
  option_name_ru: string;
  option_name_de: string;
};

export type optionTypeNameLangType = {
  option_type_name_en: string;
  option_type_name_ch: string;
  option_type_name_ja: string;
  option_type_name_th: string;
  option_type_name_es: string;
  option_type_name_fr: string;
  option_type_name_ru: string;
  option_type_name_de: string;
};

export type setPrdNameLangType = {
  set_prd_name_ch: string;
  set_prd_name_en: string;
  set_prd_name_ja: string;
  set_prd_name_th: string;
  set_prd_name_es: string;
  set_prd_name_fr: string;
  set_prd_name_ru: string;
  set_prd_name_de: string;
};

export type prdTypeNameLangType = {
  prd_type_name_ch: string;
  prd_type_name_en: string;
  prd_type_name_ja: string;
  prd_type_name_th: string;
  prd_type_name_es: string;
  prd_type_name_fr: string;
  prd_type_name_ru: string;
  prd_type_name_de: string;
};

export type storeDescriptionLangType = {
  store_description_en: string;
  store_description_ch: string;
  store_description_ja: string;
  store_description_th: string;
  store_description_es: string;
  store_description_fr: string;
  store_description_ru: string;
  store_description_de: string;
};

export type sectorNameLangType = {
  sector_name_ch?: string;
  sector_name_en?: string;
  sector_name_ja?: string;
  sector_name_th?: string;
  sector_name_es?: string;
  sector_name_fr?: string;
  sector_name_ru?: string;
  sector_name_de?: string;
};

export type parentStoreSectorNameLangType = {
  parent_store_sector_name_en: string;
  parent_store_sector_name_ch: string;
  parent_store_sector_name_ja: string;
  parent_store_sector_name_th: string;
  parent_store_sector_name_es: string;
  parent_store_sector_name_fr: string;
  parent_store_sector_name_ru: string;
  parent_store_sector_name_de: string;
};

export type descriptionNotiLangType = {
  description_noti_en: string;
  description_noti_ch: string;
  description_noti_ja: string;
  description_noti_th: string;
  description_noti_es: string;
  description_noti_fr: string;
  description_noti_ru: string;
  description_noti_de: string;
};

export type descriptionEventLangType = {
  description_event_en: string;
  description_event_ch: string;
  description_event_ja: string;
  description_event_th: string;
  description_event_es: string;
  description_event_fr: string;
  description_event_ru: string;
  description_event_de: string;
};

export type setPrdTypeNameLangType = {
  set_prd_type_name_en: string;
  set_prd_type_name_ch: string;
  set_prd_type_name_ja: string;
  set_prd_type_name_th: string;
  set_prd_type_name_es: string;
  set_prd_type_name_fr: string;
  set_prd_type_name_ru: string;
  set_prd_type_name_de: string;
};

export type titleLangType = {
  title_en: string;
  title_ch: string;
  title_ja: string;
  title_th: string;
  title_es: string;
  title_fr: string;
  title_ru: string;
  title_de: string;
};

export type contentLangType = {
  content_en: string;
  content_ch: string;
  content_ja: string;
  content_th: string;
  content_es: string;
  content_fr: string;
  content_ru: string;
  content_de: string;
};

export type OrderInfoType = {
  order: {
    order_id: string;
    area_number: number;
    number: number;
    is_active: number;
    is_complete: number;
    completed_at: string | null;
    child: {
      order_seq: number;
      order_status: number;
      ordered_at: string;
      payment_type: number;
      payment_status: number;
      bill_number: string;
      order_nr: null;
      order_service: number;
      order_type: number;
      total_amount_org: number;
      discount_amount: number;
      store_discount_amount: number;
      com_discount_amount: number;
      tax: number;
      prd_discount_amount: number;
      inquiry: string;
      total_amount_incl: number;
      prepared_at: string | null;
      picked_up_at: string | null;
      cancelled_at: string | null;
      cancel_description: string | null;
      pickup_name: string | null;
      pickup_name_en: string | null;
      delivery_tip: number;
      room_tip: number;
      detail: (productNameLangType & {
        product_id: number;
        product_seq: number;
        set_product_seq: number;
        product_name: string;
        product_name_translate_id: number;
        is_set: number;
        has_option: number;
        product_status: number;
        product_price: number;
        product_discount_name: string;
        product_discount_amount: number;
        product_quantity: number;
        product_tax: number;
        product_tax_name: string | null;
        product_tax_rate: string;
        product_total_amount: number;
        request_id: null;
        request_message: null;
        prepared_at: string | null;
        cancelled_at: string | null;
        cancel_description: string | null;
        set_prd_type_list: (setPrdTypeNameLangType & {
          set_prd_type_id: number;
          set_prd_type_name: string;
          set_prd_type_min: number;
          set_product: (productNameLangType & {
            product_id: number;
            product_name: string;
            product_name_translate_id: number;
            product_total_amount: number;
            options: (optionNameLangType &
              optionTypeNameLangType & {
                option_type: number;
                option_type_name: string;
                option_type_name_translate_id: number;
                option_id: number;
                option_price: number;
                option_name: string;
                option_name_translate_id: number;
              })[];
          })[];
        })[];
        options: (optionNameLangType &
          optionTypeNameLangType & {
            option_id: number;
            option_name: string;
            option_name_translate_id: number;
            option_type_id: number;
            option_type_name: string;
            option_type_name_translate_id: number;
            option_price: number;
          })[];
      })[];
    }[];
  };
  payment: paymentRealmType[][];
};

export type OrderDataType = {
  order_id: string;
  order_seq: number;
  store_id: number;
  store_name: string;
  phone_number: string;
  order_status: number;
  created_at: string;
  confirmed_at: string;
  prepared_at: string;
  completed_at: string;
  cancelled_at: string;
  cancel_description: string;
  delivery_expected_at: string | null;
  delivery_completed_at: string | null;
  order_category: number;
};

export type orderDetailOptionType = optionNameLangType &
  optionTypeNameLangType & {
    option_id: number;
    option_type_id: number;
    option_type_name: string;
    option_type_name_translate_id: number;
    option_name: string;
    option_name_translate_id: number;
    option_price: number;
    created_at?: Date;
    updated_at?: Date;
  };

export type orderDetailRealmType = productNameLangType & {
  store_id: number;
  product_id: number;
  hour_extension?: number;
  category_id: number;
  product_seq: number;
  set_product_seq: number;
  product_name: string;
  product_name_translate_id: number;
  is_set?: number;
  has_option?: number;
  product_status?: number;
  product_org_price: number;
  product_price: number;
  prdouct_discount_percentage: number;
  product_discount_name: string;
  product_discount_amount: number;
  product_quantity: number;
  product_tax_rate?: string;
  product_tax_name?: string;
  product_total_amount: number;
  product_type: number;
  confirm_type: number;
  request_id?: number;
  request_message?: string;
  prepared_at?: Date;
  cancelled_at?: Date;
  cancel_description?: string;
  created_at?: Date;
  updated_at?: Date;
  option_price?: number;
  options: orderDetailOptionType[];
  set_product: pickGroupListType[];
  // products: orderDetailRealmType[];
  // set_options?: orderDetailRealmType[];
};

export type orderChildRealmType = {
  order_id: string;
  order_seq: number;
  order_status?: number;
  number?: number;
  area_nr?: number;
  ordered_at?: Date;
  payment_type: number;
  payment_status?: number;
  bill_number?: string;
  order_nr?: string;
  order_service: number;
  order_type: number;
  total_amount_org: number;
  discount_amount: number;
  tax: number;
  total_amount_incl: number;
  prepared_at?: Date;
  picked_up_at?: Date;
  cancelled_at?: Date;
  cancel_description?: string;
  status?: number;
  created_at: Date;
  updated_at: Date;
  orderDetails: orderDetailRealmType[];
  order_complete: boolean;
  paid_at?: Date;
  detail?: orderDetailRealmType[];

  phone_number?: string;
  people_number?: number;
  child_number?: number;
  wait_yn?: boolean;
  wait_id?: string;
};

export type orderRealmType = {
  store_id: number;
  order_id: string;
  number: number;
  area_nr: number;
  order_service: number;
  parent_store_id?: number;
  is_complete?: number;
  completed_at?: Date;
  status?: number;
  created_at: Date;
  updated_at: Date;
  orderChilds: orderChildRealmType[];
  payments: paymentRealmType[];
  discounts: number[];
  send_server: boolean;
};

export type paymentRealmType = {
  tran_result?: boolean;
  tran_msg?: string;
  payment_id?: string;
  store_id?: string | number;
  order_id?: string;
  bill_number?: string;
  order_seq?: string | number;
  pay_seq?: string | number;
  van_type?: string;
  tran_type?: string;
  pay_type?: string;
  easy_type?: string;
  response_code?: string;
  amount?: number;
  vat_amount?: number;
  service_amount?: number;
  installment?: number;
  approval_no?: string;
  approval_date?: string;
  org_payment_id?: string;
  org_approval_no?: string;
  org_approval_date?: string;
  cancel_fg?: number;
  issuer_code?: string;
  issuer_name?: string;
  acquirer_code?: string;
  acquirer_name?: string;
  store_no?: string;
  cat_id?: string;
  balance?: string;
  response_msg?: string;
  card_no?: string;
  card_type?: string;
  tran_management_no?: string;
  tran_serial_no?: string;
  occurrence_point?: string;
  available_point?: string;
  accumulated_point?: string;
  cashback_store?: string;
  cashback_approval_no?: string;
  dcc_flag?: string;
  device_number?: string;
  key_data?: string;
  store_data?: string;
  edc_flag?: string;
  gift_amt?: string;
  biz_no?: string;
  notice?: string;
  cash_type?: string;
  cash_no?: string;
  send_server?: boolean;
  created_at?: Date;
  order_created_at?: Date;
  updated_at?: Date;
  cancelled_at?: Date;
  payment_at?: Date;
  org_payment_at?: Date;
};

export type RequestOrderProudctType = {
  store_id: number;
  store_name: string;
  order_id: string;
  number: number;
  area_number: number;
  parent_store_id: number | null;
  parent_store_name: string;
  is_active: number;
  order: {
    order_seq: number;
    order_status: number;
    order_category: number;
    ordered_at: string;
    bill_number: string;
    order_nr: null | number;
    order_type: number;
    order_service: number;
    payment_method: number;
    total_amount_org: number;
    discount_amount: number;
    prd_discount_amount: number;
    store_discount_amount: number;
    com_discount_amount: number;
    tax: number;
    total_amount_incl: number;
    payment_type: number;
    payment_status: number;
    pickup_type: number;
    pickup_name: string;
    pickup_name_en: string;
    delivery_tip: number;
    room_tip: number;
    email?: string | null;
    phone_number?: string | null;
    card_name?: string;
    order_check_type?: number | null; // (order_category:4 일경우만사용) 1:카톡발송 2:이메일발송
    delivery_address: string;
    delivery_address_detail: string;
    delivery_type: number;
    lang: number;
    inquiry: string | null;
    confirm_type: number;
    products: // setPrdTypeNameLangType &
    {
      category_id: number;
      product_id: number;
      // product_name: string;
      // product_name_en: string;
      // product_name_ch: string;
      // product_name_ja: string;
      // product_name_th: string;
      product_name_translate_id: number;
      has_option: number;
      is_set: number;
      product_type: number;
      hour_extension?: number;
      product_seq: number;
      product_price: number;
      product_discount_name: string;
      product_discount_amount: number;
      set_prd_type_seq: number;
      set_product_seq: number;
      set_prd_type_id: number;
      set_prd_type_name_translate_id: number | null;
      // set_prd_type_name: string;
      product_status: number;
      product_quantity: number;
      product_tax: number;
      product_tax_name: null | string;
      product_tax_rate: string;
      product_total_amount: number;
      request_id: null | number;
      request_message: null | string;
      options?: {
        option_id: number | string;
        // option_name: string;
        // option_name_en: string;
        // option_name_ch: string;
        // option_name_ja: string;
        // option_name_th: string;
        option_name_translate_id: number;
        option_price: number;
        option_type_id: number;
        // option_type_name: string;
        // option_type_name_en: string;
        // option_type_name_ch: string;
        // option_type_name_ja: string;
        // option_type_name_th: string;
        option_type_name_translate_id: number;
      }[];
      products: pickGroupListType[];
    }[];
  };
  payments: paymentRealmType[];
  coupons: CouponType[];
};

export type CouponType = {
  coupon_id: number;
  coupon_detail_id?: number;
  coupon_code?: number;
  coupon_name: string;
  coupon_description: string;
  coupon_type: number;
  price: number;
  percent: number;
  max_discount: number;
  start_date: string;
  end_date: string;
  is_count_limit: number;
  count_limit: number;
  count_sent: number;
  count_used: number;
  requirement: number;
  partner_percent: number;
  hq_percent: number;
  partnership: number;
  partner_discount: number;
  hq_discount: number;
  created_at: string;
  duplicate_user: number;
};

export type OrderCouponType = {
  com_discount_amount: number;
  coupon_detail_id: number;
  coupon_id: number;
  coupon_name: string;
  store_discount_amount: number;
  used_at: string;
};
